module.exports = __webpack_public_path__ + "img/9788939206021.53485979.jpg";